import { APIS } from '../constants/apis';
import { fetchAPI } from '../utils/fetchAPI';

export const deleteVideo = async ({ jwt, videoId }) => {
  try {
    await fetchAPI({
      url: `${APIS.deleteVideo}${videoId}`,
      method: 'DELETE',
      header: {
        Authorization: `Bearer ${jwt}`,
      },
    });
  } catch (err) {
    throw new Error(err.message);
  }
};
